import { Component, effect, EventEmitter, inject, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { SpeedDialModule } from 'primeng/speeddial';
import { CommonModule } from '@angular/common';
import { AvatarModule } from 'primeng/avatar';
import { PromotersProfileUi } from '@ribera-web/promoters-dashboard-ui';
import { Router, RouterModule } from '@angular/router';
import { ITEMS_BAR, TabKey } from '../data/items';
import { AccordionModule } from 'primeng/accordion';
import { AuthSessionPromotersUtil } from '@ribera-web/auth-data-acess';
import { LoginStateService, UserDataStateService, UserTypeStateService } from '@ribera-web/auth-data-acess';
import { JwtUtil } from '@ribera-web/token-decodifier-service';
import { Popover, PopoverModule } from 'primeng/popover';
import { Tooltip } from 'primeng/tooltip';

@Component({
  selector: 'lib-sidebar-promoters',
  imports: [CommonModule, SpeedDialModule, AvatarModule, PromotersProfileUi, RouterModule, AccordionModule, PopoverModule, Tooltip],
  templateUrl: './sidebar-promoters.html',
  styleUrl: './sidebar-promoters.scss',
})
export class SidebarPromoters implements OnInit {

  private authSessionService = inject(AuthSessionPromotersUtil);

  loggedUserName = '';
  avatarUrl = '/member/dashboard/user-image-default.png';

  private readonly DEFAULT_TOKEN =
    'eyJhbGciOiJIUzM4NCJ9.eyJzdWIiOiJZQTQwNjYxMjY4Iiwicm9sZXMiOlt7ImF1dGhvcml0eSI6IjEifV0sImlkIjo3NTcsInN0YXRlIjoiQUNUSVZFIiwiaWF0IjoxNzYyMjkyOTU0LCJleHAiOjE3NjIyOTY1NTR9.LaBt-Ay5UQW1MBJhme0igZ9GKDLsMf-83eQN_enpsKCCig0QAOalftCRpwgrDqaB';


  isCollapsed = false;
  @Output() toggleSidebar = new EventEmitter<boolean>();

  private userDataSateService = inject(UserDataStateService);
  private userTypeService = inject(UserTypeStateService);
  private loginState = inject(LoginStateService);
  private router = inject(Router);
  private jwtUtil = inject(JwtUtil);

  userDataResponse = this.userDataSateService.userDataResponse;

  constructor() {
    effect(() => {
      const responseUserData = this.userDataResponse();
      if (responseUserData?.data) {
        this.loggedUserName = `${responseUserData.data.firstName} ${responseUserData.data.lastName}`;
      }
    });

    // Inicializa nombre y avatar desde el token si existe y NO es el token por defecto
    const token = localStorage.getItem('accessToken');
    if (token && token !== this.DEFAULT_TOKEN) {
      try {
        const userData = this.jwtUtil.getUserFromToken(token);
        this.loggedUserName = userData.fullName || userData.name || '';
        this.avatarUrl = userData.picture || userData.avatar || this.avatarUrl;
      } catch {
        // Ignorar errores de parseo y mantener valores por defecto
      }
    }
  }

  ngOnInit(): void {
    console.log("sidebarOnInit");
    const savedCollapsed = localStorage.getItem('sidebarCollapsed');
    if (savedCollapsed !== null) {
      this.isCollapsed = savedCollapsed === 'true';
      this.toggleSidebar.emit(this.isCollapsed);
    }
    this.loadState();
  }

  get isLoggedIn(): boolean {
    // Verifica si hay un token válido (no el token por defecto)
    const token = localStorage.getItem('accessToken');
    return !!token && token !== this.DEFAULT_TOKEN;
  }

  collapseOrExpand() {
    this.isCollapsed = !this.isCollapsed;
    this.toggleSidebar.emit(this.isCollapsed);
    localStorage.setItem('sidebarCollapsed', String(this.isCollapsed));
    if(this.isCollapsed){
      this.toggleSubmenuHiddenAll();
    }else{
      this.loadState();
    }
    
  }

  toggleSubmenuHiddenAll(){
    this.navbar.forEach(item => {
      if(item.children){
        item.expanded = false;
      }
    });
  }


  get isBookingActive(): boolean {
    const bookingFlowRoutes = ['/bookings', '/checkout', '/payment'];
    return bookingFlowRoutes
      .some(route => this.router.url.startsWith(route));
  }

  get isBookingCollapsedActive(): boolean {
    const bookingFlowRoutes = ['/bookings', '/member-booking-feature'];
    return bookingFlowRoutes
      .some(route => this.router.url.startsWith(route));
  }

  logoOut() {
    this.authSessionService.logout();
    this.router.navigate(['/auth/logout']);
    setTimeout(() => {
      window.location.href = '/home';
    }, 800);
    // this.router.navigate(['/home']);
  }

  readonly navbar = ITEMS_BAR

  active: TabKey = 'inicio';

  navigate(path?: string) {
    if (!path) return;
    this.router.navigate([path]);
    console.log('Path navegado:', path);
    this.active = this.navbar.find(item => 
      item.path === path || (item.children && item.children.some(child => child.path === path))
    )?.key ?? 'inicio';
    // localStorage.setItem('pathState', path);
  }

  toggleSubmenu(key: string) {
    console.log('Toggling submenu for key:', key);
    this.navbar.forEach(item => {
      if (item.key === key) {
        item.expanded = !item.expanded;
        const storageKey = {'id': key, 'expanded': item.expanded};
        localStorage.setItem('sidebarState', JSON.stringify(storageKey));
      } else {
        item.expanded = false;
      }
    });
  }

  loadState(){
    const storedState = localStorage.getItem('sidebarState');
    if (storedState) {
      const { id, expanded } = JSON.parse(storedState);
      this.navbar.forEach(item => {
          if (item.key === id) {
            item.expanded = expanded;
          }
      });
    }

    const pathState = localStorage.getItem('pathState');
    if (pathState) {
      console.log('Path state encontrado en localStorage:', pathState);
      this.navigate(pathState);
    }

    const storedCollapsed = localStorage.getItem('sidebarCollapsed');
    if (storedCollapsed) {
      this.isCollapsed = JSON.parse(storedCollapsed);
    }
  }

  @ViewChildren('popover') popovers!: QueryList<Popover>;

  handleLinkClick(event: Event, item: any, currentPopover: Popover) {
    event.stopPropagation(); // Evitamos que el evento suba al nav

    if (this.isCollapsed) {
      // CASO COLAPSADO: Abrir popover y opcionalmente navegar/marcar activo
      this.popovers.forEach(p => {
        if (p !== currentPopover) p.hide();
      });
      if(item.children){
        currentPopover.toggle(event);
      }
      // this.navigate(item.path); 
      this.active = item.key;
      // Si quieres que también navegue al clickear el icono aunque esté colapsado:
      
    } else {
      // CASO EXPANDIDO: Navegación normal y abrir/cerrar hijos
      // this.navigate(item.path);
      this.toggleSubmenu(item.key);
    }
  }

}
